<template>
	<div class="container">
		<el-tabs v-model="activeName" @tab-click="handleClick" :class="'custom-tabs-' + activeName">
			<el-tab-pane label="单个查询" v-if="isAdmin||isAgent" name="wnQuery">
				<div class="handle-box">
					<el-input size="small" v-model="phone" clearable maxlength="12" placeholder="号码"
						style="width: 180px;" class="handle-input mr10"></el-input>
					<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
						@click="getWnPhoneInfo">搜索</el-button>
				</div>
				<div class="table-box" v-if="woData">
					<div class="user-info-box">
						<div class="user-info-tit">账户信息</div>
						<div class="info-box">
							<div class="info-name">当前状态：</div>
							<div class="info" style="">
								{{ woData.state }}
							</div>
						</div>
						<div class="info-box">
							<div class="info-name">免卡类型：</div>
							<div class="info">
								{{ woData.prdName }}
							</div>
						</div>
						<div class="info-box">
							<div class="info-name">来电显示：</div>
							<div class="info" v-if="woData.isCallerId">已开通</div>
							<div class="info" v-else>未开通</div>
						</div>
						<div class="info-box">
							<div class="info-name">用户姓名：</div>
							<div class="info">{{ woData.custName }}</div>
						</div>
						<div class="info-box">
							<div class="info-name">身份证号：</div>
							<div class="info">{{ woData.idNo }}</div>
						</div>
					</div>
					<div class="user-info-box">
						<div class="user-info-tit">账户余额</div>
						<div class="info-box">
							<div class="info-name">兔兔币：</div>
							<div class="info">
								{{ woData.tutuFee }}
							</div>
						</div>
						<div class="info-box">
							<div class="info-name">通信卷：</div>
							<div class="info">
								{{ woData.coupnFee }}
							</div>
						</div>
						<div class="info-box">
							<div class="info-name">未释放赠送账本：</div>
							<div class="info">{{ woData.givePhoneFee }}</div>
						</div>
						<div class="info-box">
							<div class="info-name">开户时间：</div>
							<div class="info" v-if="woData.checkTime">
								{{ toDateTimeStr(Number(woData.checkTime)) }}
							</div>
							<div class="info" v-else></div>
						</div>
					</div>
					<div class="user-info-box">
						<div class="user-info-tit">资费余量</div>
						<div class="info-box">
							<div class="info-name">剩余流量：</div>
							<div class="info">
								{{ woData.dataBalance }}MB
							</div>
						</div>
						<div class="info-box">
							<div class="info-name">剩余语音：</div>
							<div class="info">
								{{ woData.voiceBalance }}
							</div>
						</div>
						<div class="info-box">
							<div class="info-name">剩余短信：</div>
							<div class="info">
								{{ woData.smsBalance }}
							</div>
						</div>
					</div>
				</div>
				<el-table :data="tableData8" border class="table" ref="multipleTable" max-height="600"
					header-cell-class-name="table-header" :row-style="{ height: '20px' }" v-loading="loading"
					:cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe>
					<el-table-column prop="agent" label="代理商" align="center" show-overflow-tooltip></el-table-column>
					<el-table-column prop="company" label="企业名称" align="center" show-overflow-tooltip></el-table-column>
					<el-table-column prop="phone" label="手机号" width="130" align="center"></el-table-column>
					<el-table-column prop="status" label="状态" width="90" align="center">
						<template #default="scope">
							<el-tooltip class="item" effect="dark" :content="scope.row.errMsg" placement="top"
								v-if="scope.row.status == '提交失败'">
								<span style="color: #f56c6c;">{{ scope.row.status }}</span>
							</el-tooltip>
							<span v-else>{{ scope.row.status }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="type" label="类型" align="center" width="100">
						<template #default="scope">
							<span v-if="scope.row.type == '强停'" class="status_color2 bgred">{{ scope.row.type }}</span>
							<span v-if="scope.row.type == '强开'"
								class="status_color2 bggreen">{{ scope.row.type }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="operateMsg" label="原因" align="center"
						show-overflow-tooltip></el-table-column>
					<el-table-column prop="createdAt" label="记录时间" align="center" width="155"></el-table-column>
					<el-table-column label="复机" align="center" width="120">
						<template #default="scope">
							<span @click="getRecordVisible(scope.row)"
								style="cursor: pointer;color: #ff0000;">记录复机</span>
						</template>
					</el-table-column>
					<el-table-column prop="userPhone" label="操作者" align="center" width="130"></el-table-column>

				</el-table>
			</el-tab-pane>

			<el-tab-pane label="批量查询" v-if="isAdmin||isAgent" name="wnBatchQuery">
				<div class="handle-box">
					<el-button size="small" type="primary" :class="[theme]"
						@click="getbatchQueryRecord">批量查询</el-button>
					<a :href="`${path}dxtQuery.txt`" class="down" style="margin:10px 10px;" download="批量查询模板.txt"
						:class="[theme]">
						<i class="el-icon-download"></i>
						下载模板
					</a>
					<el-button size="small" type="primary" :class="[theme]" @click="batchQueryRecords">刷新</el-button>
				</div>
				<el-table :data="tableData" border class="table" ref="multipleTable" max-height="600"
					header-cell-class-name="table-header" :row-style="{ height: '20px' }" v-loading="loading"
					:cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe>
					<el-table-column prop="uid" label="处理批次" align="center" width="350"></el-table-column>
					<el-table-column prop="count" label="总数量" align="center"></el-table-column>
					<el-table-column prop="success" label="成功" align="center"></el-table-column>
					<el-table-column prop="err" label="失败" align="center">
						<template #default="scope">
							<span style="color: #f56c6c;">{{ scope.row.err }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="time" label="时间" align="center"></el-table-column>
					<el-table-column prop="userPhone" label="操作者" align="center"></el-table-column>
					<el-table-column label="操作" width="240" align="center">
						<template #default="scope">
							<a :href="scope.row.url" class="down" download="蜗牛用户信息批量查询数据.text" :class="[theme]">
								<i class="el-icon-download"></i>
								下载
							</a>
						</template>
					</el-table-column>
				</el-table>
				<div class="pagination">
					<el-pagination background layout="total, sizes, prev, pager, next, jumper"
						:current-page="batchquery.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
						:page-size="batchquery.pageSize" :total="pageTotal" @size-change="handleSizeChange"
						@current-change="handlePageChange"></el-pagination>
				</div>
			</el-tab-pane>

			<el-tab-pane label="开户进度" v-if="isAdmin" name="accountOpeningProgress">
				<div class="handle-box">
					<el-input size="small" v-model="query9.phoneNum" clearable placeholder="请输入手机号码"
						style="width: 180px;" class="handle-input mr10"></el-input>
					<el-input size="small" v-model="query9.name" clearable placeholder="请输入客户姓名" style="width: 180px;"
						class="handle-input mr10"></el-input>
					<el-input size="small" v-model="query9.idNo" clearable placeholder="请输入身份证号" style="width: 180px;"
						class="handle-input mr10"></el-input>
					<el-date-picker size="small" v-model="timeArr" type="daterange" unlink-panels range-separator="至"
						start-placeholder="开始日期" end-placeholder="结束日期" @change="getTime"></el-date-picker>
					<el-select size="small" v-model="query9.orderState" filterable clearable placeholder="请选择订单状态"
						class="handle-select" style="width: 180px;margin-left: 10px;">
						<el-option v-for="item in orderStateList" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
					<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search" class="m_l_10"
						@click="getopenAcctSchedule">搜索</el-button>
				</div>
				<el-table :data="tableData9" border class="table" ref="multipleTable" max-height="600"
					header-cell-class-name="table-header" :row-style="{ height: '20px' }" v-loading="loading"
					:cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe>
					<el-table-column prop="phoneNum" label="手机号码" align="center" width="120"></el-table-column>
					<el-table-column prop="name" label="客户姓名" align="center" width="80"></el-table-column>
					<el-table-column prop="idNo" label="证件号码" align="center" width="150"></el-table-column>

					<el-table-column prop="prdName" label="号码套餐" align="center" min-width="180"></el-table-column>

					<el-table-column prop="verifyMethod" label="验证方式" align="center" width="90"></el-table-column>
					<el-table-column prop="submitTime" label="提交时间" align="center" width="100">
						<template #default="scope">
							{{ timestampToDateString2(scope.row.submitTime) }}
						</template>
					</el-table-column>
					<el-table-column prop="orderState" label="订单状态" align="center" width="90">
						<template #default="scope">
							<span v-if="scope.row.orderState == 'TR'">已退款</span>
							<span v-if="scope.row.orderState == 'NON_PAY'">未支付</span>
							<span v-if="scope.row.orderState == 'PAY_SUCCESS'">支付成功</span>
							<span v-if="scope.row.orderState == 'PAY_FAILED'">支付失败</span>
							<span v-if="scope.row.orderState == 'TUTU_RECHARGE_SUCCESS'">充值成功</span>
							<span v-if="scope.row.orderState == 'TUTU_RECHARGE_FAILED'">充值失败</span>
						</template>
					</el-table-column>
					<el-table-column prop="money" label="应付金额" align="center" width="100">
						<template #default="scope">
							<span>{{ scope.row.money }}元</span>
						</template>
					</el-table-column>
					<el-table-column prop="phoneBill" label="内含话费" align="center" width="100">
						<template #default="scope">
							<span>{{ scope.row.phoneBill }}元</span>
						</template>
					</el-table-column>
					<el-table-column prop="checkTime" label="审核时间" align="center" width="100">
						<template #default="scope">
							<span v-if="scope.row.checkTime">{{ timestampToDateString2(scope.row.checkTime) }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="checkOpinion" label="审核意见" align="center"></el-table-column>
					<el-table-column prop="idAddress" label="证件地址" align="center" width="180"></el-table-column>
					<el-table-column prop="source" label="开户来源" align="center" width="80">
						<template #default="scope">
							<span v-if="scope.row.source == 'MOBILE'">移动端</span>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="140" align="center" fixed="right">
						<template #default="scope">
							<el-button size="small" style="cursor: pointer;color: #ff0000;" type="text"
								@click="bigImg(scope.row)">查看图片</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="pagination">
					<el-pagination background layout="total, sizes, prev, pager, next, jumper"
						:current-page="query9.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
						:page-size="query9.pageSize" :total="pageTotal9" @size-change="handleSizeChange"
						@current-change="handlePageChange"></el-pagination>
				</div>
			</el-tab-pane>

			<el-tab-pane label="停复机" v-if="isAdmin" name="WNrestartRecordList">
				<div class="handle-box">
					<el-select size="small" @change="agentChange" v-model="query8.agentId" filterable clearable
						placeholder="代理商" class="handle-select mr10" style="width: 260px">
						<el-option v-for="item in agents" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
					<el-select size="small" style="width: 260px" v-model="query8.companyId" @change="companyChange"
						filterable clearable placeholder="企业" class="handle-select mr10">
						<el-option v-for="item in companys" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
					<el-input size="small" v-model="query8.phone" clearable maxlength="12" placeholder="号码"
						style="width: 180px;" class="handle-input mr10"></el-input>
					<el-input size="small" v-model="query8.uid" clearable placeholder="订单编号" style="width: 230px;"
						class="handle-input mr10"></el-input>
					<el-select size="small" style="width: 100px" v-model="query8.status" filterable clearable
						placeholder="类型" class="handle-select mr10">
						<el-option v-for="item in rechargeList" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
					<el-select size="small" style="width: 100px" v-model="query8.succeed" filterable clearable
						placeholder="状态" class="handle-select mr10">
						<el-option v-for="item in succeedStopList" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
					<el-input size="small" v-model="query8.operateMsg" clearable placeholder="请输入原因"
						class="handle-input mr10" style="width: 180px;"></el-input>
					<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search" class="m_t_10"
						@click="getstopOrOpenRecord">搜索</el-button>
					<el-button size="small" type="primary" :class="[theme]" icon="el-icon-plus" class="m_t_10"
						@click="showrestartVisible">添加停复机</el-button>
					<el-button size="small" type="primary" :class="[theme]" class="m_t_10"
						@click="showlimitationVisible">限制返档</el-button>
					<el-button size="small" type="primary" :class="[theme]" icon="el-icon-upload2  el-icon--right"
						@click="exportData" v-if="query8.operateMsg">导出</el-button>
				</div>
				<el-table :data="tableData8" border class="table" ref="multipleTable" max-height="600"
					header-cell-class-name="table-header" :row-style="{ height: '20px' }" v-loading="loading"
					:cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe>
					<el-table-column prop="agent" label="代理商" align="center" show-overflow-tooltip></el-table-column>
					<el-table-column prop="company" label="企业名称" align="center" show-overflow-tooltip></el-table-column>
					<el-table-column prop="phone" label="手机号" width="130" align="center"></el-table-column>
					<el-table-column prop="status" label="状态" width="90" align="center">
						<template #default="scope">
							<el-tooltip class="item" effect="dark" :content="scope.row.errMsg" placement="top"
								v-if="scope.row.status == '提交失败'">
								<span style="color: #f56c6c;">{{ scope.row.status }}</span>
							</el-tooltip>
							<span v-else>{{ scope.row.status }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="type" label="类型" align="center" width="100">
						<template #default="scope">
							<span v-if="scope.row.type == '强停'" class="status_color2 bgred">{{ scope.row.type }}</span>
							<span v-if="scope.row.type == '强开'"
								class="status_color2 bggreen">{{ scope.row.type }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="operateMsg" label="原因" align="center"
						show-overflow-tooltip></el-table-column>
					<el-table-column prop="createdAt" label="记录时间" align="center" width="155"></el-table-column>
					<el-table-column label="复机" align="center" width="120">
						<template #default="scope">
							<span @click="getRecordVisible(scope.row)"
								style="cursor: pointer;color: #ff0000;">记录复机</span>
						</template>
					</el-table-column>
					<el-table-column prop="userPhone" label="操作者" align="center" width="130"></el-table-column>
					<el-table-column prop="uid" label="订单编号" width="310" align="center">
						<template #default="scope">
							<span style="cursor: pointer;">
								<i @click="getdownloadStopOrOpenRecord(scope.row.uid)" class="el-icon-download"
									:class="[theme3]" style="margin-right:10px;font-weight: 600;"></i>
								<span @click="copyUrl(scope.row.uid)">{{ scope.row.uid }}</span>
							</span>
						</template>
					</el-table-column>
				</el-table>
				<div class="pagination">
					<el-pagination background layout="total, sizes, prev, pager, next, jumper"
						:current-page="query8.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
						:page-size="query8.pageSize" :total="pageTotal8" @size-change="handleSizeChange"
						@current-change="handlePageChange"></el-pagination>
				</div>
			</el-tab-pane>

			<el-tab-pane label="异常话单" v-if="isAdmin||isAgent" name="WNAbnormalCallList">
				<div class="handle-box">
					<el-select size="small" @change="agentChange" v-if="isAdmin" v-model="query10.agentId" filterable
						clearable placeholder="代理商" class="handle-select mr10" style="width: 260px">
						<el-option v-for="item in agents" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
					<el-select size="small" v-if="isSubAgent" v-model="query10.subAgentId"
						@change="getfetchDefaultCompanies" filterable clearable placeholder="子代理"
						class="handle-select mr10" style="width: 260px;">
						<el-option v-for="item in subAgentList" :key="item.id" :label="item.name"
							:value="item.id"></el-option>
					</el-select>
					<el-select size="small" style="width: 260px;" v-model="query10.companyId" @change="companyChange"
						filterable clearable placeholder="企业" class="handle-select mr10">
						<el-option v-for="item in companys" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
					<el-input size="small" v-model="query10.phone" clearable maxlength="12" placeholder="号码"
						style="width: 180px;" class="handle-input mr10"></el-input>
					<el-date-picker size="small" v-model="timeArr" type="daterange" unlink-panels range-separator="至"
						start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
					<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search" class="m_l_10"
						@click="getdxtErrRecord">搜索</el-button>
				</div>
				<el-table :data="tableData10" border class="table" ref="multipleTable" max-height="600"
					header-cell-class-name="table-header" :row-style="{ height: '20px' }" v-loading="loading"
					:cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe>
					<el-table-column prop="agentName" label="代理商" align="center"></el-table-column>
					<el-table-column prop="companyName" label="企业名称" align="center"></el-table-column>
					<el-table-column prop="phone" label="手机号" align="center"></el-table-column>
					<el-table-column prop="phoneNumber" label="被叫号码" align="center"></el-table-column>
					<el-table-column prop="time" label="时间" align="center"></el-table-column>
				</el-table>
				<div class="pagination">
					<el-pagination background layout="total, sizes, prev, pager, next, jumper"
						:current-page="query10.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
						:page-size="query10.pageSize" :total="pageTotal10" @size-change="handleSizeChange"
						@current-change="handlePageChange"></el-pagination>
				</div>
			</el-tab-pane>

			<el-tab-pane label="充值" v-if="isAdmin" name="wnRecharge">
				<div class="handle-box">
					<el-input size="small" v-model="singlequery.phone" clearable placeholder="充值号码"
						style="width: 180px;" class="handle-input mr10"></el-input>
					<el-input size="small" v-model="singlequery.batchNo" clearable maxlength="12" placeholder="批次号"
						style="width: 180px;" class="handle-input mr10"></el-input>
					<el-date-picker size="small" v-model="timeArr" type="daterange" unlink-panels range-separator="至"
						start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
					<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
						@click="getsnailShowRemittanceInfo" class="m_t_10 m_l_10">搜索</el-button>
					<el-button size="small" type="primary" :class="[theme]" @click="getAdd"
						class="m_t_10">充值</el-button>
					<el-button size="small" type="primary" :class="[theme]" @click="getAPPAdd"
						class="m_t_10">APP充值</el-button>
					<span style="font-weight: 600;line-height: 40px;margin-left: 10px;font-size: 14px;">
						当前可用缴费余额：
						<span style="color: #ff0000;font-size: 14px">{{ balance }}</span>
						兔兔币
					</span>
				</div>
				<el-table :data="singletableData" border class="table" ref="multipleTable"
					header-cell-class-name="table-header" :row-style="{ height: '20px' }" v-loading="loading"
					:cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe>
					<el-table-column prop="orderNo" label="订单号" align="center" width="300"></el-table-column>
					<el-table-column prop="batchNo" label="批次号" align="center"></el-table-column>
					<el-table-column prop="rechargeNumber" label="充值号码" align="center" width="130"></el-table-column>
					<el-table-column prop="money" label="划账金额" align="center"></el-table-column>
					<el-table-column prop="operateType" label="划账类型" align="center">
						<template #default="scope">
							<span v-if="scope.row.operateType == 'DRE'">代理商充值</span>
							<span v-if="scope.row.operateType == 'BRO'">批量回退</span>
							<span v-if="scope.row.operateType == 'DP'">代理商带预存</span>
						</template>
					</el-table-column>
					<el-table-column prop="operateTime" label="提交时间" width="180" align="center">
						<template #default="scope">
							{{ timestampToDateString2(scope.row.operateTime) }}
						</template>
					</el-table-column>
					<el-table-column prop="deductNumber" label="划账号码" align="center" width="130"></el-table-column>
					<el-table-column prop="balance" label="当前余额" align="center" width="130"></el-table-column>
				</el-table>
				<div class="pagination">
					<el-pagination background layout="total, sizes, prev, pager, next, jumper"
						:current-page="singlequery.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
						:page-size="singlequery.pageSize" :total="singletotal" @size-change="handleSizeChange"
						@current-change="handlePageChange"></el-pagination>
				</div>
			</el-tab-pane>

			<el-tab-pane label="批量加白" v-if="isAdmin" name="WNWhitelist">
				<div class="handle-box">
					<el-input size="small" v-model="query11.importFileName" clearable placeholder="请输入文件名称"
						style="width: 360px;" class="handle-input mr10"></el-input>
					<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search" class="m_l_10"
						@click="getContrastInfo">搜索</el-button>
					<el-button size="small" type="primary" :class="[theme]" icon="el-icon-plus" class="m_t_10"
						@click="handleAddWNWhite">添加</el-button>
				</div>
				<el-table :data="tableData11" border class="table" ref="multipleTable" max-height="600"
					header-cell-class-name="table-header" :row-style="{ height: '20px' }" v-loading="loading"
					:cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe>
					<el-table-column prop="operNo" label="操作工号" align="center" width="160"></el-table-column>
					<el-table-column prop="operName" label="操作人" align="center" width="160"></el-table-column>
					<el-table-column prop="importFileName" label="导入文件名" align="center"></el-table-column>
					<el-table-column prop="fileUrl" label="下载地址" align="center" width="100">
						<template #default="scope">
							<a :href="scope.row.fileUrl" style="cursor: pointer;color: #ff0000;" download="加白记录.text">
								<i class="el-icon-download"></i>
								下载文件
							</a>
						</template>
					</el-table-column>
					<el-table-column prop="exportFileName" label="下载文件名" align="center"></el-table-column>
					<el-table-column prop="createTime" label="创建时间" align="center">
						<template #default="scope">
							<span>{{ toDateTimeStr(scope.row.createTime) }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="finishTime" label="完成时间" align="center">
						<template #default="scope">
							<span>{{ toDateTimeStr(scope.row.finishTime) }}</span>
						</template>
					</el-table-column>
				</el-table>
				<div class="pagination">
					<el-pagination background layout="total, sizes, prev, pager, next, jumper"
						:current-page="query11.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
						:page-size="query11.pageSize" :total="pageTotal11" @size-change="handleSizeChange"
						@current-change="handlePageChange"></el-pagination>
				</div>
			</el-tab-pane>

			<el-tab-pane label="预存款" v-if="isAdmin" name="preDeposit">
				<div class="handle-box">
					<el-form label-width="120px" :model="preDepositForm" ref="preDepositForm" style="width: 450px;">
						<el-form-item label="类型">
							<el-radio-group v-model="preDepositForm.radio">
								<el-radio label="单个预存">单个预存</el-radio>
								<el-radio label="批量预存">批量预存</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="号码" v-if="preDepositForm.radio=='单个预存'">
							<el-input size="small" v-model="preDepositForm.phone" clearable maxlength="12"
								placeholder="号码" style="width: 180px;" class="handle-input mr10"></el-input>
							<span v-if="preDepositAmount">含有预存款:{{preDepositAmount}}元</span>
						</el-form-item>
						<el-form-item label="批量上传预存款" v-if="preDepositForm.radio=='批量预存'">
							<el-input size="small" type="textarea" :rows="5" placeholder="一行一个号码"
								v-model="preDepositForm.phones"></el-input>
						</el-form-item>
						<el-form-item label="充值金额">
							<el-input size="small" v-model="preDepositForm.fee" clearable maxlength="12"
								placeholder="充值金额" style="width: 180px;" class="handle-input mr10" :value="formattedFee"
								@input="handleInput"></el-input>
						</el-form-item>
						<el-form-item class="dis-end">
							<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
								@click="getPrepayQuery" v-if="preDepositForm.radio=='单个预存'">查询</el-button>
							<el-button size="small" type="primary" :class="[theme]" @click="getPrepayAdd"
								v-if="preDepositForm.radio=='单个预存'">充值</el-button>
							<el-button size="small" type="primary" :class="[theme]" @click="getPrepayAddbatch"
								v-if="preDepositForm.radio=='批量预存'">充值</el-button>
						</el-form-item>
					</el-form>
				</div>
			</el-tab-pane>

			<el-tab-pane label="预存款记录" v-if="isAdmin" name="preDepositRecord">
				<div class="handle-box">
					<el-input size="small" v-model="query6.phone" clearable maxlength="12" placeholder="号码"
						style="width: 180px;" class="handle-input mr10"></el-input>
					<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
						@click="getFindPageByOperNo">搜索</el-button>
				</div>
				<el-table :data="tableData6" border class="table" ref="multipleTable" max-height="600"
					header-cell-class-name="table-header" :header-cell-style="{ 'text-align': 'center' }"
					v-loading="loading" :row-style="{ height: '20px' }" :cell-style="{ padding: '6px' }" stripe>
					<el-table-column prop="sessionIdStr" label="SessionlD" align="center"></el-table-column>
					<el-table-column prop="prestoreNum" label="电话号码" align="center"></el-table-column>
					<el-table-column prop="feeNum" label="预存金额" align="center"></el-table-column>
					<el-table-column prop="statusName" label="充值状态" align="center"></el-table-column>
					<el-table-column prop="date" label="导入时间" align="center"></el-table-column>
					<el-table-column label="操作" width="190" align="center">
						<template #default="scope">
							<el-button size="small" type="danger" icon="el-icon-delete" v-if="scope.row.status ==1"
								@click="handleedelete(scope.row)">退款</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="pagination">
					<el-pagination background layout="total, sizes, prev, pager, next, jumper"
						:current-page="query6.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
						:page-size="query6.pageSize" :total="pageTotal6" @size-change="handleSizeChange"
						@current-change="handlePageChange"></el-pagination>
				</div>
			</el-tab-pane>

			<el-tab-pane label="批量销户" v-if="isAdmin" name="batchAccountClosure">
				<div class="handle-box">
					<el-input size="small" v-model="query12.name" clearable placeholder="请输入文件名" style="width: 180px;"
						class="handle-input mr10"></el-input>
					<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search" class="m_t_10"
						@click="getBatchCancellations">搜索</el-button>
					<el-button size="small" type="primary" :class="[theme]" icon="el-icon-plus" class="m_t_10"
						@click="handlebatchAccountClosureAdd">批量销户</el-button>
				</div>
				<el-table :data="tableData12" border class="table" ref="multipleTable" max-height="600"
					header-cell-class-name="table-header" :row-style="{ height: '20px' }" v-loading="loading"
					:cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe>
					<el-table-column prop="operNo" label="操作工号" align="center" width="130"></el-table-column>
					<el-table-column prop="operName" label="操作人" align="center" width="130"></el-table-column>
					<el-table-column prop="importFileName" label="导入文件名" align="center"></el-table-column>
					<el-table-column prop="fileUrl" label="下载地址" align="center" width="100">
						<template #default="scope">
							<a style="cursor: pointer;color: #ff0000;" download="销户记录.text"
								@click="downloadFile(scope.row.fileUrl)">
								<i class="el-icon-download"></i>
								下载文件
							</a>
						</template>
					</el-table-column>
					<el-table-column prop="exportFileName" label="下载文件名" align="center"></el-table-column>
					<el-table-column prop="createTime" label="创建时间" width="160" align="center">
						<template #default="scope">
							<span>{{ toDateTimeStr(scope.row.createTime) }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="finishTime" label="完成时间" width="160" align="center">
						<template #default="scope">
							<span>{{ toDateTimeStr(scope.row.finishTime) }}</span>
						</template>
					</el-table-column>
				</el-table>
				<div class="pagination">
					<el-pagination background layout="total, sizes, prev, pager, next, jumper"
						:current-page="query12.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
						:page-size="query12.pageSize" :total="pageTotal12" @size-change="handleSizeChange"
						@current-change="handlePageChange"></el-pagination>
				</div>
			</el-tab-pane>

			<el-tab-pane label="回退" v-if="isAdmin" name="wnRechargeBack">
				<div class="handle-box">
					<el-input size="small" v-model="htquery.fileName" clearable placeholder="文件名称" style="width: 180px;"
						class="handle-input mr10"></el-input>
					<el-button size="small" type="primary" :class="[theme]" @click="getsnailTopUpRecord"
						icon="el-icon-search">搜索</el-button>
					<el-button size="small" type="primary" :class="[theme]" @click="getBackVisible">回退</el-button>
				</div>
				<el-table :data="batchtableData" border class="table" ref="multipleTable"
					header-cell-class-name="table-header" :row-style="{ height: '20px' }" v-loading="loading"
					:cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe>
					<el-table-column prop="operNo" label="操作号码" align="center" width="130"></el-table-column>
					<el-table-column prop="operName" label="操作人" align="center" width="130"></el-table-column>
					<el-table-column prop="importFileName" label="导入文件名" align="center"></el-table-column>
					<el-table-column prop="fileUrl" label="下载地址" align="center" width="120">
						<template #default="scope">
							<a :href="scope.row.fileUrl" style="cursor: pointer;color: #ff0000;">
								<i class="el-icon-download"></i>
								下载文件
							</a>
						</template>
					</el-table-column>
					<el-table-column prop="exportFileName" label="下载文件名" align="center"></el-table-column>
					<el-table-column prop="createTime" label="创建时间" align="center">
						<template #default="scope">
							{{ timestampToDateString2(scope.row.createTime) }}
						</template>
					</el-table-column>
					<el-table-column prop="finishTime" label="完成时间" align="center">
						<template #default="scope">
							{{ timestampToDateString2(scope.row.finishTime) }}
						</template>
					</el-table-column>
				</el-table>
				<div class="pagination">
					<el-pagination background layout="total, sizes, prev, pager, next, jumper"
						:current-page="batchquery.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
						:page-size="batchquery.pageSize" :total="batchpageTotal" @size-change="handleSizeChange"
						@current-change="handlePageChange"></el-pagination>
				</div>
			</el-tab-pane>

			<el-tab-pane label="呼叫限频" v-if="isAdmin" name="frequencyLimit">
				<div class="handle-box">
					<el-input size="small" v-model="query7.phoneNumber" clearable placeholder="请输入号码" class="mr10"
						style="width: 180px;"></el-input>
					<el-button size="small" type="primary" :class="[theme]" @click="getdeptParam">查询</el-button>
					<el-button size="small" type="primary" :class="[theme]" @click="getImport">导入号码</el-button>
					<el-button size="small" type="primary" :class="[theme]"
						@click="batchDeletefrequencyLimit2">批量删除</el-button>
				</div>
				<el-table :data="tableData7" border class="table" ref="multipleTable" max-height="600"
					header-cell-class-name="table-header" :row-style="{ height: '20px' }" v-loading="loading"
					:cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe
					@selection-change="handleSelectionChange">
					<el-table-column type="selection" width="55" align="center"></el-table-column>
					<el-table-column prop="paramValue" label="手机号码" align="center">
						<template #default="scope">
							{{ scope.row.paramValue.split('-')[0] }}
						</template>
					</el-table-column>
					<el-table-column prop="paramValue" label="呼叫频次" align="center">
						<template #default="scope">
							{{ scope.row.paramValue.split('-')[1] }}
						</template>
					</el-table-column>
					<el-table-column label="操作" width="240" align="center">
						<template #default="scope">
							<el-button size="small" type="danger" :class="[theme]"
								@click="batchDeletefrequencyLimit(scope.row)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="pagination">
					<el-pagination background layout="total, sizes, prev, pager, next, jumper"
						:current-page="query7.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
						:page-size="query7.pageSize" :total="pageTotal7" @size-change="handleSizeChange"
						@current-change="handlePageChange"></el-pagination>
				</div>
			</el-tab-pane>
		</el-tabs>
		<el-dialog title="批量查询" v-model="wnBatchQueryVisible" width="520px" @close="closewnBatchQueryDialog">
			<el-form label-width="120px" :model="wnBatchQueryForm" ref="wnBatchQueryForm">
				<el-form-item label="上传类型" prop="type">
					<el-radio-group v-model="wnBatchQueryForm.type">
						<el-radio label="2">手动输入</el-radio>
						<el-radio label="1">批量查询模板</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="上传文件" v-if="wnBatchQueryForm.type=='1'">
					<el-upload ref="upload1" action="/api/Snail/batchQuery" :headers="token" :limit="1"
						:on-success="uploadwnBatchQuerySuccess" :auto-upload="false" :data="upload1Data">
						<el-button size="small" type="primary" :class="[theme]"
							style="margin-top: 40px;">选择文件</el-button>
						<div class="el-upload__tip">只能导入txt文件</div>
					</el-upload>
				</el-form-item>
				<el-form-item label="批量查询" v-if="wnBatchQueryForm.type=='2'">
					<el-input size="small" :rows="5" type="textarea" v-model="wnBatchQueryForm.phones"
						auto-complete="off" placeholder="一行一个手机号码,一次最多添加500个号码"></el-input>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="closewnBatchQueryDialog">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" v-if="wnBatchQueryForm.type == '2'"
						@click="getwnbatchQuery">确定</el-button>
					<el-button size="small" type="primary" :class="[theme]" v-else
						@click="submitwnBatchQueryUpload">文件上传</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="回退" v-model="backVisible" width="520px" @close="closeBackDialog">
			<el-form label-width="120px" :model="backForm" ref="backForm">
				<el-form-item label="选择模式">
					<el-radio-group v-model="backForm.type">
						<el-radio label="1">手动输入</el-radio>
						<el-radio label="2">批量模板</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="手机号码" prop="phones" v-if="backForm.type == '1'">
					<el-input size="small" :rows="5" type="textarea" v-model="backForm.phones" auto-complete="off"
						placeholder="一行一个,最多可回退500个号码"></el-input>
				</el-form-item>
				<el-form-item label="上传文件" prop="" v-if="backForm.type == '2'">
					<el-upload ref="upload4" action="/api/Snail/BatchDeduction" :headers="token" :limit="1"
						:on-success="uploadSuccess4" :auto-upload="false" :data="backForm">
						<el-button size="small" type="primary" :class="[theme]"
							style="margin-top: 40px;">选择文件</el-button>
						<div class="el-upload__tip">只能导入txt文件</div>
					</el-upload>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="closeBackDialog">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" v-if="backForm.type == '1'"
						@click="getSnailBatchDeduction">确定</el-button>
					<el-button size="small" type="primary" :class="[theme]" v-if="backForm.type == '2'"
						@click="submitBackUpload">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="充值" v-model="singleVisible" width="520px" @close="closesingleDialog">
			<el-form label-width="120px" :model="singleForm" ref="editForm">
				<el-form-item label="选择模式">
					<el-radio-group v-model="singleForm.type">
						<el-radio label="1">手动输入</el-radio>
						<el-radio label="2">批量模板</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="金额" v-if="singleForm.type == '1'">
					<el-radio-group v-model="singleForm.amount">
						<el-radio v-for="item in amountList" :key="item.value" :label="item.value" :value="item.value"
							style="margin: 18px 10px;float: left;">
							{{ item.label }}
						</el-radio>
						<el-input v-model="singleForm.amount" size="small" placeholder="其他金额"
							style="width: 160px;margin: 5px 10px;float: left;" type="number"></el-input>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="手机号码" prop="phones" v-if="singleForm.type == '1'">
					<el-input size="small" :rows="5" type="textarea" v-model="singleForm.phones" auto-complete="off"
						placeholder="一行一个,英文逗号分隔,支持批量充值"></el-input>
				</el-form-item>
				<el-form-item label="示例" v-if="singleForm.type == '2'">
					<div style="display: flex;flex-direction: column;">
						<span>17012345678,10</span>
						<span>一行一个英文逗号分隔</span>
					</div>
				</el-form-item>
				<el-form-item label="上传文件" prop="" v-if="singleForm.type == '2'">
					<el-upload ref="uploadSingle" action="/api/Snail/topUp" :headers="token" :limit="1"
						:on-success="uploadSingleSuccess" :auto-upload="false" :data="singleForm">
						<el-button size="small" type="primary" :class="[theme]"
							style="margin-top: 40px;">选择文件</el-button>
						<div class="el-upload__tip">只能导入txt文件</div>
					</el-upload>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="closesingleDialog">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" v-if="singleForm.type == '1'"
						@click="getSnailTopUp">确定</el-button>
					<el-button size="small" type="primary" :class="[theme]" v-if="singleForm.type == '2'"
						@click="submitSingleUpload">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="APP充值" v-model="APPVisible" width="450px" @close="closeAPPDialog">
			<el-form label-width="120px" :model="APPForm" ref="editForm">
				<el-form-item label="APP充值:" prop="bon">
					<el-radio-group v-model="APPForm.bon">
						<el-radio :label="true">开启</el-radio>
						<el-radio :label="false">关闭</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="closeAPPDialog">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" @click="getstopDxtApp">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog v-model="filterBox" width="460px">
			<div class="filter-box">
				<div>
					<i class="el-icon-success" style="color: #40FF63;"></i>
					导入成功：{{ successData.length }}条
				</div>
				<div v-if="failedData.length > 0" @click="errortab = true" class="icon-class">
					<i class="el-icon-error" style="color: #FFB640;"></i>
					格式错误：
					<span>{{ failedData.length }}</span>
					条
				</div>
				<div v-else>
					<i class="el-icon-error" style="color: #FFB640;"></i>
					格式错误：0 条
				</div>
			</div>
		</el-dialog>
		<el-dialog v-model="errortab" width="470px">
			<el-table :data="failedData" border class="table" ref="multipleTable" header-cell-class-name="table-header"
				:row-style="{ height: '20px' }" :cell-style="{ padding: '6px' }"
				:header-cell-style="{ 'text-align': 'center' }">
				<el-table-column prop="label" label="号码" align="center" width="200"></el-table-column>
				<el-table-column prop="value" label="原因" align="center"></el-table-column>
			</el-table>
		</el-dialog>
		<el-dialog title="导入号码" v-model="frequencyLimitVisible" width="520px" @close="closefrequencyLimitDialog">
			<el-form label-width="120px" :model="frequencyLimitForm" ref="frequencyLimitForm">
				<el-form-item label="频次" v-if="deletefrequencyLimitDowm">
					<el-input size="small" v-model="frequencyLimitForm.succeed" placeholder="请输入限频次数"></el-input>
				</el-form-item>
				<el-form-item label="号码">
					<el-input size="small" type="textarea" :rows="5" placeholder="一行一个号码"
						v-model="frequencyLimitForm.phones"></el-input>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="closefrequencyLimitDialog">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" @click="getAddFrequencyLimit"
						v-if="deletefrequencyLimitDowm">确定</el-button>
					<el-button size="small" type="primary" :class="[theme]" @click="batchDeletefrequencyLimit3"
						v-else>批量删除</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

		<el-dialog title="添加停复机" v-model="restartVisible" width="520px" @close="closerestartDialog">
			<el-form label-width="120px" :model="restartForm" ref="restartForm">
				<el-form-item label="选择模式" prop="tab1">
					<el-radio-group v-model="tab1">
						<el-radio label="input">手动输入</el-radio>
						<el-radio label="fled">批量停开机模板</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="类型" prop="operState">
					<el-radio-group v-model="restartForm.operState">
						<el-radio label="F0N">强开</el-radio>
						<el-radio label="F0F">强停</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="手机号码" prop="phones" v-if="tab1 == 'input'">
					<el-input size="small" :rows="5" type="textarea" v-model="restartForm.phones" auto-complete="off"
						placeholder="一行一个手机号码,一次最多添加500个号码"></el-input>
				</el-form-item>
				<el-form-item label="上传文件" prop="" v-else>
					<el-upload ref="uploadrestart" action="/api/Snail/FileStopOrOpen" :headers="token" :limit="1"
						:on-success="uploadrestartSuccess" :auto-upload="false" :data="restartForm">
						<el-button size="small" type="primary" :class="[theme]"
							style="margin-top: 40px;">选择文件</el-button>
						<div class="el-upload__tip">只能导入txt文件</div>
					</el-upload>
				</el-form-item>
				<el-form-item label="原因" prop="reason">
					<el-input size="small" :rows="5" type="textarea" v-model="restartForm.reason" auto-complete="off"
						placeholder="请输入停复机原因"></el-input>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="closerestartDialog">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" v-if="tab1 == 'input'"
						@click="stopOrOpens">确定</el-button>
					<el-button size="small" type="primary" :class="[theme]" v-else
						@click="submitrestartUpload">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="限制返档" v-model="limitationVisible" width="520px" @close="closelimitationDialog">
			<el-form label-width="120px" :model="limitationForm" ref="limitationForm">
				<el-form-item label="选择模式" prop="type">
					<el-radio-group v-model="limitationForm.type">
						<el-radio label="1">手动输入</el-radio>
						<el-radio label="2">批量模板</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="类型" prop="batchNo">
					<el-radio-group v-model="limitationForm.batchNo">
						<el-radio label="BATCH_REMOVE">解除限制返档</el-radio>
						<el-radio label="BATCH_FORBID">批量限制返档</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="手机号码" prop="phones" v-if="limitationForm.type == '1'">
					<el-input size="small" :rows="5" type="textarea" v-model="limitationForm.phones" auto-complete="off"
						placeholder="一行一个手机号码,一次最多添加500个号码"></el-input>
				</el-form-item>
				<el-form-item label="上传文件" prop="" v-else>
					<el-upload ref="uploadlimitation" action="/api/Snail/ReverseFile" :headers="token" :limit="1"
						:on-success="uploadlimitationSuccess" :auto-upload="false" :data="limitationForm">
						<el-button size="small" type="primary" :class="[theme]"
							style="margin-top: 40px;">选择文件</el-button>
						<div class="el-upload__tip">只能导入txt文件</div>
					</el-upload>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="closelimitationDialog">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" v-if="limitationForm.type == '1'"
						@click="getReverseFile">确定</el-button>
					<el-button size="small" type="primary" :class="[theme]" v-else
						@click="submitlimitationUpload">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="自动复机设置" v-model="repeatedVisible" width="520px" @close="closerepeatedDialog">
			<el-form label-width="120px" :model="repeatedForm" ref="repeatedForm">
				<el-form-item label="是否记录" prop="record">
					<el-radio-group v-model="repeatedForm.record">
						<el-radio :label="true">是</el-radio>
						<el-radio :label="false">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="是否复机" prop="recover">
					<el-radio-group v-model="repeatedForm.recover" disabled>
						<el-radio :label="true">是</el-radio>
						<el-radio :label="false">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="复机时间" prop="hours" v-if="repeatedForm.record">
					<el-radio-group v-model="repeatedForm.hours">
						<el-radio v-for="item in hoursList" :key="item.value" :label="item.value" :value="item.value"
							style="margin: 12px 52px 12px 0;">{{ item.label }}</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="记录时间" prop="updatedAt">
					<el-input size="small" v-model="repeatedForm.updatedAt" disabled></el-input>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="closerepeatedDialog">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" @click="getRecordingRecover">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog v-model="imgVisible" width="1000px">
			<div style="display: flex;flex-direction: row;">
				<div>
					<el-image style="height: 300px; width: 100%;" :src="srcList[0]" fit="contain"
						:preview-src-list="srcList"></el-image>
					<el-image style="height: 300px; width: 100%;" :src="srcList[1]" fit="contain"
						:preview-src-list="srcList"></el-image>
				</div>
				<div><el-image style="height: 600px; width: 100%;" :src="srcList[2]" fit="contain"
						:preview-src-list="srcList"></el-image></div>
			</div>
		</el-dialog>

		<el-dialog title="批量加白" v-model="WNWhitelistVisible" width="520px" @close="closeWNWhitelistDialog">
			<el-form label-width="120px" :model="WNWhitelistForm" ref="WNWhitelistForm">
				<el-form-item label="选择模式" prop="tab1">
					<el-radio-group v-model="tab1">
						<el-radio label="input">手动添加</el-radio>
						<el-radio label="fled">批量添加</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="类型" prop="status">
					<el-radio-group v-model="WNWhitelistForm.status">
						<el-radio label="0">新增</el-radio>
						<el-radio label="1">删除</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="手机号码" prop="phones" v-if="tab1 == 'input'">
					<el-input size="small" :rows="5" type="textarea" v-model="WNWhitelistForm.phones"
						auto-complete="off" placeholder="一行一个手机号码,一次最多添加500个号码"></el-input>
				</el-form-item>
				<el-form-item label="上传文件" prop="" v-else>
					<el-upload ref="uploadWNWhitelist" action="/api/Snail/FileBatchWhitening" :headers="token"
						:limit="1" :on-success="uploadWNWhitelistSuccess" :auto-upload="false" :data="WNWhitelistForm">
						<el-button size="small" type="primary" :class="[theme]"
							style="margin-top: 40px;">选择文件</el-button>
						<div class="el-upload__tip">只能导入txt文件</div>
					</el-upload>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="closeWNWhitelistDialog">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" v-if="tab1 == 'input'"
						@click="getBatchWhitening">确定</el-button>
					<el-button size="small" type="primary" :class="[theme]" v-else
						@click="submitWNWhitelistUpload">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="添加销户" v-model="batchAccountClosureVisible" width="520px"
			@close="closebatchAccountClosureDialog">
			<el-form label-width="120px" :model="batchAccountClosureForm" ref="batchAccountClosureForm">
				<el-form-item label="选择模式" prop="tab1">
					<el-radio-group v-model="batchAccountClosureForm.type">
						<el-radio label="1">手动输入</el-radio>
						<el-radio label="2">批量销户模板</el-radio>
					</el-radio-group>
				</el-form-item>

				<el-form-item label="手机号码" prop="phones" v-if="batchAccountClosureForm.type == '1'">
					<el-input size="small" :rows="5" type="textarea" v-model="batchAccountClosureForm.phones"
						auto-complete="off" placeholder="一行一个手机号码,一次最多添加500个号码"></el-input>
				</el-form-item>
				<el-form-item label="上传文件" prop="" v-else>
					<el-upload ref="uploadbatchAccountClosure" action="/api/Snail/batchCancellation" :headers="token"
						:limit="1" :on-success="uploadbatchAccountClosureSuccess" :auto-upload="false"
						:data="batchAccountClosureForm">
						<el-button size="small" type="primary" :class="[theme]"
							style="margin-top: 40px;">选择文件</el-button>
						<div class="el-upload__tip">只能导入txt文件</div>
					</el-upload>
				</el-form-item>
				<el-form-item label="原因" prop="batchNo">
					<el-input size="small" :rows="5" type="textarea" v-model="batchAccountClosureForm.batchNo"
						auto-complete="off" placeholder="请输入停复机原因"></el-input>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="closebatchAccountClosureDialog">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" v-if="batchAccountClosureForm.type == '1'"
						@click="batchCancellation">确定</el-button>
					<el-button size="small" type="primary" :class="[theme]" v-else
						@click="submitbatchAccountClosureUpload">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>
<script>
	import {
		fetchDepartment
	} from '../api/index';
	import {
		fetchAgent
	} from '../api/agentIndex';
	import {
		fetchCompanyByAgentId,
		fetchDefaultCompanies
	} from '../api/companyIndex';
	import {
		WnPhoneInfo,
		batchQueryRecord,
		stopOrOpenRecord,
		batchQuery,
		findPageByOperNo,
		prepayQuery,
		prepayAdd,
		prepayRecoil,
		prepayAddbatch,
		deptParam,
		AddFrequencyLimit,
		deleteBatch
	} from '../api/wn.js';

	import {
		fundPoolAdd,
		fundPool,
		snailShowRemittanceInfo,
		batchTopUpRecord,
		topUpRecordDownload,
		snailTopUp,
		stopWNApp,
		WNEnabled,
		snailBatchDeduction,
		snailTopUpRecord,
		queryDeptBalance,
		stopOrOpenRecordList,
		WNdownloadStopOrOpenRecord,
		SnailStopOrOpen,
		reverseFile,
		RecordingRecover,
		fastdfsfile,
		openAcctSchedule,
		fastdfsfile2,
		SnailErrRecord,
		BatchWhitening,
		getContrastInfo,
		getBatchCancellation,
		batchCancellation,
	} from '../api/dijia.js';
	import {
		log
	} from '../api/jssip-3.6.3';
	export default {
		name: 'WNvirtualCommerce',
		data() {
			return {
				loading: false,
				theme: localStorage.getItem('theme'),
				theme3: localStorage.getItem('theme3'),
				theme8: localStorage.getItem('theme8'),
				phone: '',
				batchquery: {
					pageIndex: 1,
					pageSize: 10,
					userId: localStorage.getItem('user')
				},
				woData: '',
				wnBatchQueryForm: {
					userId: localStorage.getItem('user'),
					phones: '',
					type: "2",
				},
				wnBatchQueryVisible: false,
				singlequery: {
					pageIndex: 1,
					pageSize: 10,
					phone: '',
					batchNo: '',
					startTime: '',
					endTime: ''
				},
				singletableData: [],
				singletotal: 0,
				amountList: [{
						value: 10,
						label: '10兔兔币'
					},
					{
						value: 20,
						label: '20兔兔币'
					},
					{
						value: 30,
						label: '30兔兔币'
					},
					{
						value: 50,
						label: '50兔兔币'
					},
					{
						value: 100,
						label: '100兔兔币'
					},
					{
						value: 300,
						label: '300兔兔币'
					},
					{
						value: 500,
						label: '500兔兔币'
					}
				],
				singleVisible: false,
				singleForm: {
					userId: localStorage.getItem('user'),
					phones: '',
					amount: '',
					type: '1'
				},
				htquery: {
					fileName: '',
					pageIndex: 1,
					pageSize: 10,
				},
				balance: '',
				batchNumber: '',
				APPVisible: false,
				APPForm: {
					bon: false
				},
				batchtableData: [],
				batchpageTotal: 0,
				backQuery: {
					pageIndex: 1,
					pageSize: 10,
				},
				backVisible: false,
				backForm: {
					userId: localStorage.getItem('user'),
					phones: '',
					type: '1',
				},
				tableData6: [],
				query6: {
					phone: '',
					pageIndex: 1,
					pageSize: 10,
					userId: localStorage.getItem('user'),
				},
				preDepositForm: {
					userId: localStorage.getItem('user'),
					phone: '',
					fee: '',
					radio: '单个预存',
				},
				preDepositAmount: '',
				formattedFee: '',
				tableData7: [],
				pageTotal6: 0,
				query7: {
					userId: localStorage.getItem('user'),
					phoneNumber: '',
					pageIndex: 1,
					pageSize: 10,
				},
				deletefrequencyLimitDowm: false,
				frequencyLimitVisible: false,
				paramType: '',
				succeedList: [20, 40, 80, 100, 150, 200, 300],
				frequencyLimitForm: {
					userId: localStorage.getItem('user'),
					succeed: '',
					phones: '',
				},
				pageTotal7: 0,
				query8: {
					companyId: '',
					userId: localStorage.getItem('user'),
					status: '',
					phone: '',
					pageIndex: 1,
					pageSize: 10,
					uid: '',
					succeed: '',
					operateMsg: '',
				},
				pageTotal8: 0,
				tableData8: [],
				restartVisible: false,
				restartForm: {
					phones: '',
					userId: localStorage.getItem('user'),
					reason: '',
					operState: 'F0N',
				},
				limitationVisible: false,
				limitationForm: {
					userId: localStorage.getItem('user'),
					batchNo: 'BATCH_REMOVE',
					type: '1',
					phones: '',
				},
				repeatedVisible: false,
				tab1: 'input',
				repeatedForm: {
					record: false,
					recover: false,
					updatedAt: '',
					hours: '',
				},
				rechargeList: [{
					value: 0,
					label: '全部'
				}, {
					value: 1,
					label: '强开'
				}, {
					value: -1,
					label: '强停'
				}],
				succeedStopList: [{
					value: 0,
					label: '全部'
				}, {
					value: 1,
					label: '成功'
				}, {
					value: -1,
					label: '失败'
				}],
				hoursList: [{
						value: 2,
						label: '2小时'
					}, {
						value: 4,
						label: '4小时'
					}, {
						value: 6,
						label: '6小时'
					},
					{
						value: 12,
						label: '12小时'
					}, {
						value: 24,
						label: '24小时'
					}
				],
				upload1Data: {
					userId: localStorage.getItem('user'),
				},
				query9: {
					phoneNum: '',
					name: '',
					idNo: '',
					orderState: '',
					pageIndex: 1,
					pageSize: 10,
				},
				orderStateList: [{
						value: 'TR',
						label: '已退款',
					},
					{
						value: 'NON_PAY',
						label: '未支付',
					},
					{
						value: 'PAY_SUCCESS',
						label: '支付成功',
					},
					{
						value: 'PAY_FAILED',
						label: '支付失败',
					},
					{
						value: 'TUTU_RECHARGE_SUCCESS',
						label: '充值成功',
					},
					{
						value: 'TUTU_RECHARGE_FAILED',
						label: '充值失败',
					}
				],
				imgData: '',
				imgVisible: false,
				tableData9: [],
				srcList: [],
				pageTotal9: 0,
				query10: {
					companyId: '',
					userId: localStorage.getItem('user'),
					phone: '',
					pageIndex: 1,
					pageSize: 10,
					subAgentId: '',
				},
				tableData10: [],
				pageTotal10: 0,
				query11: {
					importFileName: '',
					pageIndex: 1,
					pageSize: 10,
				},
				tableData11: [],
				WNWhitelistVisible: false,
				WNWhitelistForm: {
					status: '0',
				},
				pageTotal11: 0,

				query12: {
					importFileName: '',
					userId: localStorage.getItem('user'),
					pageIndex: 1,
					pageSize: 10,
				},
				batchAccountClosureForm: {
					type: '1',
					phones: '',
					batchNo: '',
					userId: localStorage.getItem('user'),
				},
				batchAccountClosureVisible: false,
				pageTotal12: 0,
				tableData12: [],

				timeArr: [],
				tableData: [],
				multipleSelection: [],
				pageTotal: 0,

				path: process.env.BASE_URL,
				token: {
					Authorization: localStorage.getItem('token'),
					type: 'web',
					UserRole: localStorage.getItem('ms_role'),
					XSecurityVersion: 'v2',
				},
				upload: false,
				isAdmin: false,
				isAgent: false,
				isCompany: false,
				isNormal: false,
				isSubAgent: false,
				activeName: 'wnQuery',
				errortab: null, // Initial value

				agents: [],
				companys: [],
				departments: [],
				filterBox: false,

			};
		},
		watch: {
			// 监听 preDepositForm.fee 的变化，更新 formattedFee
			'preDepositForm.fee'(newVal) {
				this.formattedFee = this.formatFee(newVal);
			}
		},
		created() {
			let role = localStorage.getItem('ms_role');

			if (role === 'admin') {
				this.isAdmin = true;
			}
			if (role === 'agent') {
				this.isAgent = true;
			}
			if (role === 'normal') {
				this.isNormal = true;
			}
			if (role === 'company') {
				this.isCompany = true;
			}
			this.updateTabStyle();
			this.updatePaginationStyle();
		},
		methods: {
			updatePaginationStyle() {
				let pagination = document.getElementById('pagination');
				if (!pagination) {
					pagination = document.createElement('style');
					pagination.id = 'dynamic-tab-style';
					document.head.appendChild(pagination);
				}
				pagination.innerHTML = `
				    .el-pager .active {
				        background-color: ${this.theme8} !important;
						color: #fff !important;
				    }
					.el-pager .number:hover {
				        color: ${this.theme8} !important;
				    }
					.el-pager .active:hover {
					    color: #fff !important;
					}
					.el-pager .more:hover {
					    color: ${this.theme8} !important;
					}
				`;
			},
			updateTabStyle() {
				// 动态更新样式
				let styleEl = document.getElementById('dynamic-tab-style');
				if (!styleEl) {
					styleEl = document.createElement('style');
					styleEl.id = 'dynamic-tab-style';
					document.head.appendChild(styleEl);
				}

				styleEl.innerHTML = `
			        .el-tabs__active-bar {
			            background-color: ${this.theme8} !important;
			        }
			        .el-tabs__item.is-active {
			            color: ${this.theme8} !important;
			        }
			        .el-tabs__item:hover {
			            color: ${this.theme8} !important;
			            opacity: 0.8;
			        }
			    `;
			},
			handleClick(tab, event) {
				this.activeName = tab.props.name;
				if (tab.props.name == 'wnQuery') {
					this.tableData8 = [];
					if (this.phone) {
						this.getWnPhoneInfo();
					}
				} else if (tab.props.name == 'wnBatchQuery') {
					this.batchQueryRecords();
				} else if (tab.props.name == 'wnRecharge') {
					this.getTime();
					queryDeptBalance().then(res => {
						if (res?.code === 200) {
							this.balance = res.data;
						} else {
							this.$message.error(res.message);
						}
					});
					this.getsnailShowRemittanceInfo();
				} else if (tab.props.name == 'wnRechargeBack') {
					this.getsnailTopUpRecord();
				} else if (tab.props.name == 'preDeposit') {
					console.log('preDeposit')
				} else if (tab.props.name == 'preDepositRecord') {
					this.getFindPageByOperNo();
				} else if (tab.props.name == 'frequencyLimit') {
					this.getdeptParam();
				} else if (tab.props.name == 'WNrestartRecordList') {
					this.init();
					this.query8.agentId = '';
					this.query8.companyId = '';
					this.getstopOrOpenRecord();
				} else if (tab.props.name == 'accountOpeningProgress') {
					this.getopenAcctSchedule();
				} else if (tab.props.name == 'WNAbnormalCallList') {
					this.init();
					this.query10.agentId = '';
					this.query10.companyId = '';
					this.getTime();
					this.getdxtErrRecord();
				} else if (tab.props.name == 'WNWhitelist') {
					this.getContrastInfo();
				} else if (tab.props.name == 'batchAccountClosure') {
					this.getBatchCancellations()
				}
			},
			init() {
				fetchAgent(localStorage.getItem('user')).then(res => {
					this.agents = res.data;
				});
				this.getfetchDefaultCompanies();
			},
			getfetchDefaultCompanies() {
				this.query8.companyId = '';
				this.query10.companyId = '';
				let data = {
					currentUserId: localStorage.getItem('user'),
					subAgentId: ''
				};
				fetchDefaultCompanies(data).then(res => {
					if (res?.code === 200) {
						this.companys = res.data;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			agentChange(agentId) {
				this.query8.agentId = agentId;
				this.query8.companyId = '';
				this.query10.agentId = agentId;
				this.query10.companyId = '';
				if (agentId) {
					let data = {
						subAgent: JSON.parse(localStorage.getItem('subAgent').toLowerCase()),
						agentId: agentId
					};
					fetchCompanyByAgentId(data).then(res => {
						this.companys = res.data;
					});
				}
			},
			companyChange(companyId) {
				this.query8.companyId = companyId;
				this.query10.companyId = companyId;
				let data = {
					companyId: companyId,
					currentUserId: localStorage.getItem('user')
				};
				fetchDepartment(data).then(res => {
					this.departments = res.data;
				});
			},
			toDateTimeStr(dateTime) {
				const date = new Date(dateTime);
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份是从0开始的，所以需要+1，并用'0'填充
				const day = String(date.getDate()).padStart(2, '0');
				const hours = String(date.getHours()).padStart(2, '0');
				const minutes = String(date.getMinutes()).padStart(2, '0');
				const seconds = String(date.getSeconds()).padStart(2, '0');
				// 拼接成完整的日期时间字符串
				const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
				// 返回格式化后的日期时间字符串
				return formattedDateTime;
			},
			//筛选时间
			getTime() {
				//时间
				let startTime = new Date(new Date());
				let endTime = new Date();
				this.timeArr.push(startTime);
				this.timeArr.push(endTime);
			},
			convertDateStringToTimestamp(dateString) {
				// 假设dateString的格式为"YYYY-MM-DD"
				const parts = dateString.split('-');
				const year = parseInt(parts[0], 10);
				const month = parseInt(parts[1], 10) - 1; // 注意月份是从0开始的
				const day = parseInt(parts[2], 10);
				// 创建一个新的Date对象
				const date = new Date(year, month, day);
				// 转换为时间戳
				const timestamp = date.getTime();
				return timestamp;
			},
			timestampToDateString(timestamp) {
				const date = new Date(timestamp);
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const day = String(date.getDate()).padStart(2, '0');
				return `${year}-${month}-${day}`;
			},

			timestampToDateString2(timestamp) {
				const date = new Date(timestamp);
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const day = String(date.getDate()).padStart(2, '0');
				const hours = String(date.getHours()).padStart(2, '0');
				const minutes = String(date.getMinutes()).padStart(2, '0');
				const seconds = String(date.getSeconds()).padStart(2, '0');
				// 拼接年月日时分秒字符串
				return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
			},
			getWnPhoneInfo() {
				this.woData = '';
				this.tableData8 = [];
				WnPhoneInfo(this.phone.trim()).then(res => {
					if (res?.code === 200) {
						this.woData = res.data;
						this.getstopOrOpenRecord2();
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getstopOrOpenRecord2() {
				let data = {
					userId: localStorage.getItem('user'),
					phone: this.phone.trim(),
					pageIndex: 1,
					pageSize: 99,
				}
				this.loading = true;
				stopOrOpenRecordList(data).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData8 = res.data.list;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			batchQueryRecords() {
				this.loading = true;
				batchQueryRecord(this.batchquery).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData = res.data.list;
						this.pageTotal = res.data.total;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getwnbatchQuery() {
				batchQuery(this.wnBatchQueryForm).then(res => {
					if (res?.code === 200) {
						this.$message.success(res.data);
						this.wnBatchQueryVisible = false;
						this.batchQueryRecords();
					} else {
						this.$message.error(res.message);
					}
				});
			},
			submitwnBatchQueryUpload() {
				if (this.$refs.upload1.uploadFiles[0]) {
					this.loading = true;
					this.$refs.upload1.submit();
					this.batchQueryRecords();
				} else {
					this.$message.error('请选择上传文件');
				}
			},
			//导入上传
			uploadwnBatchQuerySuccess(success) {
				setTimeout(() => {
					this.$refs.upload1.clearFiles();
					this.wnBatchQueryVisible = false;
				}, 2000);
				if (success?.code === 200) {
					this.$message.success('上传成功');
					this.batchQueryRecords();
				} else {
					// this.open(success.message);
					this.$message.error(success.message);
				}
			},
			getbatchQueryRecord() {
				this.wnBatchQueryVisible = true;
				this.wnBatchQueryForm.phones = '';
				this.wnBatchQueryForm.type = '2';
			},
			closewnBatchQueryDialog() {
				this.wnBatchQueryVisible = false;
			},
			getsnailShowRemittanceInfo() {
				if (this.timeArr.length > 0) {
					let data = {
						phone: this.singlequery.phone,
						batchNo: this.singlequery.batchNo,
						startTime: this.convertDateStringToTimestamp(this.toDateTimeStr(this.timeArr[0])),
						endTime: this.convertDateStringToTimestamp(this.toDateTimeStr(this.timeArr[1])) + 86399000,
						pageIndex: this.singlequery.pageIndex,
						pageSize: this.singlequery.pageSize
					};
					this.loading = true;
					snailShowRemittanceInfo(data).then(res => {
						if (res?.code === 200) {
							this.loading = false;
							this.singletableData = res.data.list;
							this.singletotal = res.data.total;
						} else {
							this.loading = false;
							this.$message.error(res.message);
						}
					});
				} else {
					let data = {
						phone: this.singlequery.phone,
						batchNo: this.singlequery.batchNo,
						pageIndex: this.singlequery.pageIndex,
						pageSize: this.singlequery.pageSize
					};
					snailShowRemittanceInfo(data).then(res => {
						if (res?.code === 200) {
							this.singletableData = res.data.list;
							this.singletotal = res.data.total;
						} else {
							this.$message.error(res.message);
						}
					});
				}
			},
			closesingleDialog() {
				this.singleForm.type = '1';
				this.singleForm.phones = '';
				this.singleForm.amount = '';
				this.singleVisible = false;
			},
			getSnailTopUp() {
				if (this.singleForm.amount > this.balance) {
					this.$message.error('余额不足');
				} else {
					let data = {
						phones: this.singleForm.phones,
						amount: this.singleForm.amount,
						type: this.singleForm.type,
						file: this.singleForm.file,
						userId: localStorage.getItem('user')
					};
					snailTopUp(data).then(res => {
						if (res?.code === 200) {
							// this.filterBox = true;
							this.getsnailShowRemittanceInfo();
							this.singleVisible = false;
							// this.successData = res.data.success;
							// this.failedData = res.data.failed;
							this.$confirm(res.data, '提示', {
									type: 'success',
									confirmButtonText: '复制',
								})
								.then(() => {
									let cInput = document.createElement('input');
									cInput.value = res.data;
									document.body.appendChild(cInput);
									cInput.select();
									document.execCommand('copy');
									this.$message.success('复制成功');
									document.body.removeChild(cInput);
								})
								.catch(() => {});
						} else {
							this.$message.error(res.message);
						}
					});
				}
			},
			getAdd() {
				this.singleVisible = true;
			},
			getAPPAdd() {
				this.APPVisible = true;
				this.getdxtEnabled();
			},
			getstopDxtApp() {
				let data = {
					bon: this.APPForm.bon,
					userId: localStorage.getItem('user')
				};
				stopWNApp(data).then(res => {
					if (res?.code === 200) {
						this.$message.success(res.data);
						this.APPVisible = false;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getdxtEnabled() {
				WNEnabled().then(res => {
					if (res?.code === 200) {
						this.APPForm.bon = res.data;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			closeAPPDialog() {
				this.APPVisible = false;
			},
			getsnailTopUpRecord() {
				snailTopUpRecord(this.backQuery).then(res => {
					if (res?.code === 200) {
						this.batchtableData = res.data.list;
						this.batchpageTotal = res.data.total;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getBackVisible() {
				this.backVisible = true;
			},
			closeBackDialog() {
				this.backForm.phones = '';
				this.backForm.type = '1';
				this.backVisible = false;
			},
			getSnailBatchDeduction() {
				let data = {
					phones: this.backForm.phones,
					type: this.backForm.type,
					file: this.backForm.file,
					userId: localStorage.getItem('user')
				};
				snailBatchDeduction(data).then(res => {
					if (res?.code === 200) {
						this.$message.success(res.message);
						this.backVisible = false;
						this.backForm.phones = '';
						this.backForm.type = '1';
					} else {
						this.$message.error(res.message);
					}
				});
			},
			submitBackUpload() {
				if (this.$refs.upload4.uploadFiles[0]) {
					this.loading = true;
					this.$refs.upload4.submit();
					this.backVisible = false;
				} else {
					this.$message.error('请选择上传文件');
				}
			},
			uploadSuccess4(success) {
				this.backVisible = false;
				this.getsnailTopUpRecord();
				this.$message.success(success.message);
			},

			handleInput(value) {
				// 移除非数字字符
				let cleanedValue = value.replace(/\D/g, '');
				// 更新表单值
				this.preDepositForm.fee = cleanedValue;
				// 触发 watch 更新 formattedFee
			},
			formatFee(value) {
				// 这里可以添加额外的格式化逻辑，比如添加逗号作为千位分隔符等
				// 但对于基本正整数验证和长度限制，上面的 handleInput 已经足够
				return value;
			},
			getPrepayQuery() {
				let data = {
					userId: localStorage.getItem('user'),
					phone: this.preDepositForm.phone,
				}
				prepayQuery(data).then(res => {
					if (res?.code === 200) {
						this.preDepositAmount = res.data;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			//充值
			getPrepayAdd() {
				let data = {
					userId: localStorage.getItem('user'),
					phone: this.preDepositForm.phone,
					fee: this.preDepositForm.fee
				}
				prepayAdd(data).then(res => {
					if (res?.code === 200) {
						this.$message.success(res.data);
						this.preDepositForm.fee = '';
						this.preDepositForm.preDepositAmount = '';
						this.getPrepayQuery()
					} else {
						this.$message.error(res.message);
					}
				});
			},
			//批量充值
			getPrepayAddbatch() {
				let data = {
					userId: localStorage.getItem('user'),
					phones: this.preDepositForm.phones,
					fee: this.preDepositForm.fee
				}
				prepayAddbatch(data).then(res => {
					if (res?.code === 200) {
						this.$message.success(res.data);
						this.preDepositForm.phones = '';
						this.preDepositForm.fee = '';
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getFindPageByOperNo() {
				this.loading = true;
				findPageByOperNo(this.query6).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData6 = res.data.list;
						this.pageTotal6 = res.data.total;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			handleedelete(row) {
				this.$confirm('是否要退款此预存？', '提示', {
						type: 'warning',
						confirmButtonText: '退款',
						cancelButtonText: '不退款',
						closeOnClickModal: false
					})
					.then(() => {
						let data = {
							userId: localStorage.getItem('user'),
							id: row.sessionIdStr,
							phone: row.prestoreNum,
						}
						prepayRecoil(data).then(res => {
							if (res?.code === 200) {
								this.$message.success(res.data);
								this.getFindPageByOperNo();
							} else {
								this.$message.error(res.message);
							}
						});
					})
					.catch(() => {

					});
			},
			getdeptParam() {
				this.loading = true;
				deptParam(this.query7).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						if (res.data.list) {
							this.tableData7 = res.data.list;
							this.pageTotal7 = res.data.total;
						}
					} else {
						this.$message.error(res.message);
					}
				});
			},

			getAddFrequencyLimit() {
				AddFrequencyLimit(this.frequencyLimitForm).then(res => {
					if (res?.code === 200) {
						this.$message.success(res.data);
						this.frequencyLimitVisible = false;
						this.frequencyLimitForm.phones = '';
						this.getdeptParam();
					} else {
						this.$message.error(res.message);
					}
				});
			},
			closefrequencyLimitDialog() {
				this.frequencyLimitVisible = false;
				this.frequencyLimitForm.phones = '';
				this.deletefrequencyLimitDowm = false;
			},
			// 多选操作
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},

			getImport() {
				this.frequencyLimitVisible = true;
				this.deletefrequencyLimitDowm = true;
				this.frequencyLimitForm.succeed = '';
				this.frequencyLimitForm.phones = '';
			},
			batchDeletefrequencyLimit(row) {
				if (row.paramType) {
					this.$confirm('是否要删除此号码的拨打频次？', '提示', {
							type: 'warning',
							confirmButtonText: '删除',
							cancelButtonText: '不删除',
							closeOnClickModal: false
						})
						.then(() => {
							let data = {
								userId: localStorage.getItem('user'),
								id: row.seqId,
								paramType: row.paramType
							}
							deleteBatch(data).then(res => {
								if (res?.code === 200) {
									this.$message.success(res.data);
									this.getdeptParam();
								} else {
									this.$message.error(res.message);
								}
							});
						})
						.catch(() => {});
				}
			},
			batchDeletefrequencyLimit2() {
				for (let i = 0; i < this.multipleSelection.length; i++) {
					this.multipleSelectionStr += this.multipleSelection[i].seqId + ',';
					this.paramType = this.multipleSelection[0].paramType;
				}
				if (!this.multipleSelection == []) {
					this.frequencyLimitVisible = true;
					this.frequencyLimitForm.phones = '';
				} else {
					this.$confirm('是否要批量删除此号码的拨打频次？', '提示', {
							type: 'warning',
							confirmButtonText: '删除',
							cancelButtonText: '不删除',
							closeOnClickModal: false
						})
						.then(() => {
							let data = {
								userId: localStorage.getItem('user'),
								id: this.multipleSelectionStr,
								paramType: this.paramType
							}
							deleteBatch(data).then(res => {
								if (res?.code === 200) {
									this.$message.success(res.data);
									this.getdeptParam();
								} else {
									this.$message.error(res.message);
								}
							});
						})
						.catch(() => {});
				}
			},
			batchDeletefrequencyLimit3() {
				this.$confirm('是否要批量删除此号码的拨打频次？？？？', '提示', {
						type: 'warning',
						confirmButtonText: '删除',
						cancelButtonText: '不删除',
						closeOnClickModal: false
					})
					.then(() => {
						let data = {
							userId: localStorage.getItem('user'),
							phones: this.frequencyLimitForm.phones,
						}
						deleteBatch(data).then(res => {
							if (res?.code === 200) {
								this.$message.success(res.data);
								this.frequencyLimitVisible = false;
								this.getdeptParam();
							} else {
								this.$message.error(res.message);
							}
						});
					})
					.catch(() => {});
			},
			exportData() {
				this.loading = true;
				let data = {
					operateMsg: this.query.operateMsg
				};
				WNdownloadStopOrOpenRecord(data).then(res => {
					const blob = new Blob([res], {
						type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
					});
					let downloadElement = document.createElement('a');
					let href = window.URL.createObjectURL(blob);
					downloadElement.href = href;
					let fileName = '蜗牛停复机' + '.xls';
					downloadElement.download = fileName;
					document.body.appendChild(downloadElement);
					downloadElement.click();
					document.body.removeChild(downloadElement);
					window.URL.revokeObjectURL(href);
					this.loading = false;
				});
			},
			getstopOrOpenRecord() {
				this.loading = true;
				stopOrOpenRecordList(this.query8).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData8 = res.data.list;
						this.pageTotal8 = res.data.total;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			stopOrOpens() {
				SnailStopOrOpen(this.restartForm).then(res => {
					if (res?.code === 200) {
						this.restartVisible = false;
						this.$message.success(res.data);
						setTimeout(() => {
							this.getstopOrOpenRecord();
						}, 1000);
					} else {
						this.$message.error(res.message);
					}
				});
			},
			showlimitationVisible() {
				this.limitationVisible = true;
			},
			showrestartVisible() {
				this.restartVisible = true;
			},
			submitlimitationUpload() {
				if (this.$refs.uploadlimitation.uploadFiles[0]) {
					this.loading = true;
					this.$refs.uploadlimitation.submit();
				} else {
					this.$message.error('请选择上传文件');
				}
			},
			submitrestartUpload() {
				if (this.$refs.uploadrestart.uploadFiles[0]) {
					this.loading = true;
					this.$refs.uploadrestart.submit();
				} else {
					this.$message.error('请选择上传文件');
				}
			},
			uploadSingleSuccess(success) {
				setTimeout(() => {
					this.$refs.uploadSingle.clearFiles();
				}, 2000);
				if (success?.code === 200) {
					this.singleVisible = false;
					this.$message.success('上传成功');
					setTimeout(() => {
						this.getsnailShowRemittanceInfo();
					}, 3000);
				} else {
					this.$message.error(success.message);
				}
			},
			submitSingleUpload() {
				if (this.$refs.uploadSingle.uploadFiles[0]) {
					this.loading = true;
					this.$refs.uploadSingle.submit();
				} else {
					this.$message.error('请选择上传文件');
				}
			},
			closerestartDialog() {
				this.restartVisible = false;
				this.restartForm.phones = '';
				this.restartForm.reason = '';
				this.restartForm.operState = 'F0N';
				this.tab1 = 'input';
			},
			//导入上传
			uploadrestartSuccess(success) {
				setTimeout(() => {
					this.$refs.uploadrestart.clearFiles();
				}, 2000);
				if (success?.code === 200) {
					this.restartVisible = false;
					this.$message.success('上传成功');
					setTimeout(() => {
						this.getstopOrOpenRecord();
					}, 3000);
				} else {
					this.$message.error(success.message);
				}
			},


			getdownloadStopOrOpenRecord(uid) {
				this.$confirm('确定要下载该批次数据吗？', '提示', {
						type: 'warning'
					})
					.then(() => {
						let data = {
							uid: uid
						};
						WNdownloadStopOrOpenRecord(data).then(res => {
							const blob = new Blob([res], {
								type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
							});
							let downloadElement = document.createElement('a');
							let href = window.URL.createObjectURL(blob);
							downloadElement.href = href;
							let fileName = '停复机记录' + uid + '.xlsx';
							downloadElement.download = fileName;
							document.body.appendChild(downloadElement);
							downloadElement.click();
							document.body.removeChild(downloadElement);
							window.URL.revokeObjectURL(href);
						});
					})
					.catch(() => {});
			},
			closelimitationDialog() {
				this.limitationVisible = false;
				this.limitationForm.phones = '';
				this.limitationForm.type = '1';
				this.limitationForm.batchNo = 'BATCH_REMOVE';
			},
			//导入上传
			uploadlimitationSuccess(success) {
				setTimeout(() => {
					this.$refs.uploadlimitation.clearFiles();
				}, 2000);
				if (success?.code === 200) {
					this.$alert('上传成功，请前往浏览器下载文件夹查看反馈', '提示', {
						type: 'warning'
					}).then(() => {});
					this.limitationVisible = false;
					this.limitationForm.phones = '';
					this.limitationForm.type = '1';
					this.limitationForm.batchNo = 'BATCH_REMOVE';
					const blob = new Blob([success], {
						type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
					});
					let downloadElement = document.createElement('a');
					downloadElement.href = success.data;
					downloadElement.download = '';
					document.body.appendChild(downloadElement);
					downloadElement.click();
					document.body.removeChild(downloadElement);
					window.URL.revokeObjectURL(success.data);
					setTimeout(() => {
						this.getstopOrOpenRecord();
					}, 3000);
				} else {
					this.$message.error(success.message);
				}
			},
			getReverseFile() {
				let data = {
					userId: localStorage.getItem('user'),
					type: this.limitationForm.type,
					batchNo: this.limitationForm.batchNo,
					phones: this.limitationForm.phones
				};
				reverseFile(data).then(res => {
					if (res?.code === 200) {
						// 上传成功，请前往浏览器下载文件夹查看反馈
						this.limitationVisible = false;
						this.limitationForm.phones = '';
						this.limitationForm.type = '1';
						this.limitationForm.batchNo = 'BATCH_REMOVE';

						this.$confirm('确定要下载文件夹查看反馈吗？', '提示', {
								type: 'warning'
							})
							.then(() => {
								let data = {
									fileName: res.data
								};
								fastdfsfile(data).then(res => {
									const blob = new Blob([res], {
										type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
									});
									let downloadElement = document.createElement('a');
									let href = window.URL.createObjectURL(blob);
									downloadElement.href = href;
									let fileName = '限制记录' + '.xlsx';
									downloadElement.download = fileName;
									document.body.appendChild(downloadElement);
									downloadElement.click();
									document.body.removeChild(downloadElement);
									window.URL.revokeObjectURL(href);
								});
							})
							.catch(() => {});
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getRecordVisible(row) {
				this.repeatedVisible = true;
				this.repeatedForm.record = row.record;
				this.repeatedForm.recover = row.recover;
				this.repeatedForm.id = row.id;
				this.repeatedForm.hours = row.hours;
				this.repeatedForm.updatedAt = row.updatedAt;
			},
			closerepeatedDialog() {
				this.repeatedVisible = false;
			},
			getRecordingRecover() {
				let data = {
					id: this.repeatedForm.id,
					record: this.repeatedForm.record,
					hours: this.repeatedForm.hours
				};
				RecordingRecover(data).then(res => {
					if (res?.code === 200) {
						this.repeatedVisible = false;
						this.$message.success(res.data);
						this.getstopOrOpenRecord();
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getopenAcctSchedule() {
				this.loading = true;
				this.tableData9 = [];
				if (this.timeArr.length > 0) {
					let data = {
						phoneNum: this.query9.phoneNum.trim(),
						name: this.query9.name,
						idNo: this.query9.idNo,
						startSubmitTime: this.convertDateStringToTimestamp(this.toDateTimeStr(this.timeArr[0])),
						endSubmitTime: this.convertDateStringToTimestamp(this.toDateTimeStr(this.timeArr[1])) +
							86399000,
						orderState: this.query9.orderState,
						pageIndex: this.query9.pageIndex,
						pageSize: this.query9.pageSize
					};
					openAcctSchedule(data).then(res => {
						this.loading = false;
						if (res?.code === 200) {
							let isEmptyData = res.data == null;
							this.tableData9 = isEmptyData ? [] : res.data.list;
							this.pageTotal9 = isEmptyData ? 0 : res.data.total;
						} else {
							this.$message.error(res.message);
						}
					});
				} else {
					let data = {
						phoneNum: this.query9.phoneNum.trim(),
						name: this.query9.name,
						idNo: this.query9.idNo,
						orderState: this.query9.orderState,
						pageIndex: this.query9.pageIndex,
						pageSize: this.query9.pageSize
					};
					openAcctSchedule(data).then(res => {
						this.loading = false;
						if (res?.code === 200) {
							let isEmptyData = res.data == null;
							this.tableData9 = isEmptyData ? [] : res.data.list;
							this.pageTotal9 = isEmptyData ? 0 : res.data.total;
						} else {
							this.$message.error(res.message);
						}
					});
				}
			},
			bigImg(row) {
				this.srcList = [];
				this.imgVisible = true;
				this.getfastdfsfile(row.idFrontSimUrl)
				this.getfastdfsfile(row.idBackSimUrl)
				this.getfastdfsfile(row.idFrontUrl)

			},
			getfastdfsfile(fileName) {
				let data = {
					fileName: fileName,
					open: true,
				};
				fastdfsfile(data).then(res => {
					const blob = new Blob([res], {
						type: 'image/png'
					});
					const url = URL.createObjectURL(blob);
					this.srcList.push(url);
				});
			},
			getdxtErrRecord() {
				this.loading = true;
				this.tableData10 = [];
				// 日期
				if (this.timeArr === null) {
					this.query10.startTime = '';
					this.query10.endTime = '';
				} else {
					let startTime = this.timestampToDateString(this.timeArr[0]);
					let endTime = this.timestampToDateString(this.timeArr[1]);
					this.query10.startTime = startTime;
					this.query10.endTime = endTime;
				}
				SnailErrRecord(this.query10).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData10 = res.data.list;
						this.pageTotal10 = res.data.total;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getContrastInfo() {
				this.loading = true;
				this.tableData11 = [];
				getContrastInfo(this.query11).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData11 = res.data.list;
						this.pageTotal11 = res.data.total;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			handleAddWNWhite() {
				this.WNWhitelistVisible = true;
			},
			getBatchWhitening() {
				let data = {
					phones: this.WNWhitelistForm.phones,
					status: this.WNWhitelistForm.status,
					userId: localStorage.getItem('user')
				};
				BatchWhitening(data).then(res => {
					if (res?.code === 200) {
						this.$message.success(res.message);
						this.WNWhitelistForm.phones = '';
						this.WNWhitelistForm.status = '0';
						this.tab1 = 'input';
						this.WNWhitelistVisible = false;
					} else {
						this.$message.error(res.message);
					}
				});
			},

			submitWNWhitelistUpload() {
				if (this.$refs.uploadWNWhitelist.uploadFiles[0]) {
					this.loading = true;
					this.$refs.uploadWNWhitelist.submit();
					this.WNWhitelistForm.phones = '';
					this.WNWhitelistForm.status = '0';
					this.tab1 = 'input';
					this.$message.success('提交成功');
					this.WNWhitelistVisible = false;
				} else {
					this.$message.error('请选择上传文件');
				}
			},
			closeWNWhitelistDialog() {
				this.WNWhitelistForm.phones = '';
				this.WNWhitelistForm.status = '0';
				this.tab1 = 'input';
				this.WNWhitelistVisible = false;
			},
			getBatchCancellations() {
				this.loading = true;
				getBatchCancellation(this.query12).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData12 = res.data.list;
					} else {
						this.$message.error(res.message);
					}
				});
			},


			handlebatchAccountClosureAdd() {
				this.batchAccountClosureVisible = true;
				this.batchAccountClosureForm.batchNo = '';
				this.batchAccountClosureForm.phones = '';
				this.batchAccountClosureForm.type = '1';
			},

			submitbatchAccountClosureUpload() {
				if (this.$refs.uploadbatchAccountClosure.uploadFiles[0]) {
					this.loading = true;
					this.$refs.uploadbatchAccountClosure.submit();

				} else {
					this.$message.error('请选择上传文件');
				}
			},
			closebatchAccountClosureDialog() {
				this.batchAccountClosureVisible = false;
			},
			//导入上传
			uploadbatchAccountClosureSuccess(success) {
				setTimeout(() => {
					this.$refs.uploadbatchAccountClosure.clearFiles();
				}, 2000);
				if (success?.code === 200) {

					// this.$message.success('上传成功');
					this.$alert('销户成功，请前往浏览器下载文件夹查看反馈', '提示', {
						type: 'warning'
					}).then(() => {
						this.batchAccountClosureVisible = false;
						setTimeout(() => {
							this.getBatchCancellations();
						}, 3000);
						let data = {
							fileName: success.data,
							open: ''
						}
						fastdfsfile(data).then(res => {
							const blob = new Blob([res], {
								type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
							});
							let downloadElement = document.createElement('a');
							downloadElement.href = URL.createObjectURL(blob);
							downloadElement.download = '批量销户记录.xlsx';
							document.body.appendChild(downloadElement);
							downloadElement.click();
							document.body.removeChild(downloadElement);
							window.URL.revokeObjectURL(downloadElement.href);
						});
					});
				} else {
					this.$message.error(success.message);
				}
			},
			batchCancellation() {
				let data = {
					phones: this.batchAccountClosureForm.phones,
					type: this.batchAccountClosureForm.type,
					batchNo: this.batchAccountClosureForm.batchNo,
					userId: localStorage.getItem('user'),
				};
				batchCancellation(data).then(res => {
					if (res?.code === 200) {
						this.batchAccountClosureForm.phones = '';
						this.batchAccountClosureForm.batchNo = '';
						this.tab1 = 'input';
						this.batchAccountClosureVisible = false;
						this.$alert('销户成功，请前往浏览器下载文件夹查看反馈', '提示', {
							type: 'warning'
						}).then(() => {
							let data = {
								fileName: res.data,
								open: ''
							}
							fastdfsfile(data).then(res => {
								const blob = new Blob([res], {
									type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
								});
								let downloadElement = document.createElement('a');
								downloadElement.href = URL.createObjectURL(blob);
								downloadElement.download = '输入销户记录.xlsx';
								document.body.appendChild(downloadElement);
								downloadElement.click();
								document.body.removeChild(downloadElement);
								window.URL.revokeObjectURL(downloadElement.href);
							});
						});
						setTimeout(() => {
							this.getBatchCancellations();
						}, 3000);
					} else {
						this.$message.error(res.message);
					}
				});
			},
			downloadFile(fileName) {
				let data = {
					fileName: fileName,
					open: ''
				}
				fastdfsfile(data).then(res => {
					const blob = new Blob([res], {
						type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
					});
					let downloadElement = document.createElement('a');
					downloadElement.href = URL.createObjectURL(blob);
					downloadElement.download = '销户记录.xlsx';
					document.body.appendChild(downloadElement);
					downloadElement.click();
					document.body.removeChild(downloadElement);
					window.URL.revokeObjectURL(downloadElement.href);
					setTimeout(() => {
						this.getBatchCancellations();
					}, 3000);
				});

			},




			copyUrl(item) {
				let cInput = document.createElement('input');
				cInput.value = item;
				document.body.appendChild(cInput);
				cInput.select();
				document.execCommand('copy');
				this.$message.success('复制成功');
				document.body.removeChild(cInput);
			},
			// 分页导航
			handlePageChange(val) {
				if (this.activeName == 'wnQuery') {
					this.query1.pageIndex = val;
					this.getWnPhoneInfo();
				} else if (this.activeName == 'wnBatchQuery') {
					this.batchquery.pageIndex = val;
					this.batchQueryRecords();
				} else if (this.activeName == 'wnRecharge') {
					this.singlequery.pageIndex = val;
					queryDeptBalance().then(res => {
						if (res?.code === 200) {
							this.balance = res.data;
						} else {
							this.$message.error(res.message);
						}
					});
					this.getsnailShowRemittanceInfo();
				} else if (this.activeName == 'wnRechargeBack') {
					this.batchquery.pageIndex = val;
					this.getsnailTopUpRecord();
				} else if (this.activeName == 'preDeposit') {
					this.query5.pageIndex = val;
				} else if (this.activeName == 'preDepositRecord') {
					this.query6.pageIndex = val;
					this.getFindPageByOperNo();
				} else if (this.activeName == 'frequencyLimit') {
					this.query7.pageIndex = val;
					this.getdeptParam();
				} else if (this.activeName == 'WNrestartRecordList') {
					this.query8.pageIndex = val;
					this.getstopOrOpenRecord();
				} else if (this.activeName == 'accountOpeningProgress') {
					this.query9.pageIndex = val;
					this.getopenAcctSchedule();
				} else if (this.activeName == 'WNAbnormalCallList') {
					this.query10.pageIndex = val;
					this.getdxtErrRecord();
				} else if (this.activeName == 'WNWhitelist') {
					this.query11.pageIndex = val;
					this.getContrastInfo();
				} else if (this.activeName == 'batchAccountClosure') {
					this.query12.pageIndex = val;
					this.getBatchCancellations()
				}
			},
			handleSizeChange(val) {
				if (this.activeName == 'wnQuery') {
					this.query1.pageSize = val;
					this.query1.pageIndex = 1; // 重置到第一页
					this.getWnPhoneInfo();
				} else if (this.activeName == 'wnBatchQuery') {
					this.batchquery.pageSize = val;
					this.batchquery.pageIndex = 1; // 重置到第一页
					this.batchQueryRecords();
				} else if (this.activeName == 'wnRecharge') {
					this.singlequery.pageSize = val;
					this.singlequery.pageIndex = 1; // 重置到第一页
					queryDeptBalance().then(res => {
						if (res?.code === 200) {
							this.balance = res.data;
						} else {
							this.$message.error(res.message);
						}
					});
					this.getsnailShowRemittanceInfo();
				} else if (this.activeName == 'wnRechargeBack') {
					this.batchquery.pageSize = val;
					this.batchquery.pageIndex = 1; // 重置到第一页
					this.getsnailTopUpRecord();
				} else if (this.activeName == 'preDeposit') {
					this.query5.pageSize = val;
					this.query5.pageIndex = 1; // 重置到第一页
				} else if (this.activeName == 'preDepositRecord') {
					this.query6.pageSize = val;
					this.query6.pageIndex = 1; // 重置到第一页
					this.getFindPageByOperNo();
				} else if (this.activeName == 'frequencyLimit') {
					this.query7.pageSize = val;
					this.query7.pageIndex = 1; // 重置到第一页
					this.getdeptParam();
				} else if (this.activeName == 'WNrestartRecordList') {
					this.query8.pageSize = val;
					this.query8.pageIndex = 1; // 重置到第一页
					this.getstopOrOpenRecord();
				} else if (this.activeName == 'accountOpeningProgress') {
					this.query9.pageSize = val;
					this.query9.pageIndex = 1; // 重置到第一页
					this.getopenAcctSchedule();
				} else if (this.activeName == 'WNAbnormalCallList') {
					this.query10.pageSize = val;
					this.query10.pageIndex = 1; // 重置到第一页
					this.getdxtErrRecord();
				} else if (this.activeName == 'WNWhitelist') {
					this.query11.pageSize = val;
					this.query11.pageIndex = 1; // 重置到第一页
					this.getContrastInfo();
				} else if (this.activeName == 'batchAccountClosure') {
					this.query12.pageSize = val;
					this.query12.pageIndex = 1; // 重置到第一页
					this.getBatchCancellations()
				}
			},
		}
	};
</script>

<style scoped>
	.handle-box {
		margin-bottom: 20px;
	}

	.table-box {
		display: flex;
		flex-direction: row;
		margin-bottom: 40px;
	}

	.user-info-box {
		width: 600px;
	}

	.user-info-tit {
		background: #fafafa;
		color: #000;
		font-weight: 600;
		text-align: center;
		line-height: 34px;
		border-right: 1px solid #ebeef5;
		border-bottom: 1px solid #ebeef5;
	}

	.info-box {
		display: flex;
		flex-direction: row;
		line-height: 34px;
		border-bottom: 1px solid #ebeef5;
		border-right: 1px solid #ebeef5;
	}

	.info-name {
		background: #fafafa;
		border-right: 1px solid #ebeef5;
		border-left: 1px solid #ebeef5;
		width: 30%;
		padding-left: 10px;
		font-weight: 600;
	}

	.user-info-box .info-box .info {
		padding-left: 10px;
		color: #226003;
		width: 80%;
	}

	.down {
		border: 1px solid #dcdfe6;
		background: #4f7afd;
		color: #ffffff;
		transition: 0.1s;
		font-weight: 500;
		padding: 6px 12px;
		font-size: 12px;
		border-radius: 4px;
		display: inline-block;
	}
</style>